import type { Template } from "@/types";

export const PO_06_H4_V2: Template[] = [
{
    id: "po-06-h4v2-01",
    name: "PO 01 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 55, y: 166, width: 481, height: 405, rotation: 0, imageRotation: 0 },
            { id: "2", x: 55, y: 578, width: 155, height: 115, rotation: 0, imageRotation: 0 },
            { id: "3", x: 218, y: 578, width: 155, height: 115, rotation: 0, imageRotation: 0 },
            { id: "4", x: 381, y: 578, width: 155, height: 115, rotation: 0, imageRotation: 0 },
            { id: "5", x: 618, y: 233, width: 231, height: 388, rotation: 0, imageRotation: 0 },
            { id: "6", x: 857, y: 233, width: 230, height: 388, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-06-h4v2-02",
    name: "PO 02 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 55, y: 163, width: 481, height: 346, rotation: 0, imageRotation: 0 }, 
        { id: "2", x: 55, y: 517, width: 237, height: 173, rotation: 0, imageRotation: 0 },
        { id: "3", x: 300, y: 517, width: 236, height: 173, rotation: 0, imageRotation: 0 },
        { id: "4", x: 686, y: 163, width: 322, height: 246, rotation: 0, imageRotation: 0 },
        { id: "5", x: 686, y: 417, width: 157, height: 274, rotation: 0, imageRotation: 0 },
        { id: "6", x: 851, y: 417, width: 157, height: 274, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h4v2-03",
    name: "PO 03 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 75, y: 165, width: 193, height: 330, rotation: 0, imageRotation: 0 },
        { id: "2", x: 75, y: 503, width: 115, height: 186, rotation: 0, imageRotation: 0 },
        { id: "3", x: 198, y: 503, width: 294, height: 186, rotation: 0, imageRotation: 0 },      
        { id: "4", x: 276, y: 165, width: 216, height: 161, rotation: 0, imageRotation: 0 },
        { id: "5", x: 276, y: 334, width: 216, height: 161, rotation: 0, imageRotation: 0 },
        { id: "6", x: 621, y: 254, width: 462, height: 348, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h4v2-04",
    name: "PO 04 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 49, y: 255, width: 470, height: 344, rotation: 0, imageRotation: 0 },
        { id: "2", x: 614, y: 164, width: 236, height: 404, rotation: 0, imageRotation: 0 },
        { id: "3", x: 858, y: 164, width: 236, height: 404, rotation: 0, imageRotation: 0 },
        { id: "4", x: 614, y: 576, width: 155, height: 115, rotation: 0, imageRotation: 0 },
        { id: "5", x: 777, y: 576, width: 155, height: 115, rotation: 0, imageRotation: 0 },
        { id: "6", x: 940, y: 576, width: 154, height: 115, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h4v2-05",
    name: "PO 05 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 51, y: 173, width: 298, height: 508, rotation: 0, imageRotation: 0 },
        { id: "2", x: 357, y: 173, width: 167, height: 121, rotation: 0, imageRotation: 0 },
        { id: "3", x: 357, y: 302, width: 167, height: 121, rotation: 0, imageRotation: 0 },
        { id: "4", x: 357, y: 431, width: 167, height: 250, rotation: 0, imageRotation: 0 },
        { id: "5", x: 683, y: 173, width: 338, height: 250, rotation: 0, imageRotation: 0 },
        { id: "6", x: 683, y: 431, width: 338, height: 250, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h4v2-06",
    name: "PO 06 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 49, y: 255, width: 206, height: 346, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 263, y: 255, width: 147, height: 110, rotation: 0, imageRotation: 0 },
        { id: "3", x: 263, y: 373, width: 147, height: 110, rotation: 0, imageRotation: 0 },
        { id: "4", x: 263, y: 491, width: 147, height: 109, rotation: 0, imageRotation: 0 },
        { id: "5", x: 418, y: 255, width: 206, height: 346, rotation: 0, imageRotation: 0 },
        { id: "6", x: 632, y: 255, width: 457, height: 346, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h4v2-07",
    name: "PO 07 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 58, y: 164, width: 616, height: 527, rotation: 0, imageRotation: 0 },
        { id: "2", x: 682, y: 164, width: 160, height: 260, rotation: 0, imageRotation: 0 },
        { id: "3", x: 682, y: 432, width: 160, height: 259, rotation: 0, imageRotation: 0 },
        { id: "4", x: 850, y: 164, width: 228, height: 171, rotation: 0, imageRotation: 0 },
        { id: "5", x: 850, y: 343, width: 228, height: 170, rotation: 0, imageRotation: 0 },
        { id: "6", x: 850, y: 521, width: 228, height: 170, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h4v2-08",
    name: "PO 08 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 200, width: 292, height: 224, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 432, width: 292, height: 223, rotation: 0, imageRotation: 0 },
        { id: "3", x: 300, y: 200, width: 291, height: 224, rotation: 0, imageRotation: 0 },
        { id: "4", x: 300, y: 432, width: 291, height: 223, rotation: 0, imageRotation: 0 },
        { id: "5", x: 599, y: 200, width: 265, height: 455, rotation: 0, imageRotation: 0 },
        { id: "6", x: 872, y: 200, width: 264, height: 455, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h4v2-09",
    name: "PO 09 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 58, y: 103, width: 198, height: 320, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 264, y: 103, width: 403, height: 320, rotation: 0, imageRotation: 0 },
        { id: "3", x: 675, y: 103, width: 403, height: 320, rotation: 0, imageRotation: 0 },
        { id: "4", x: 58, y: 431, width: 403, height: 321, rotation: 0, imageRotation: 0 },
        { id: "5", x: 469, y: 431, width: 403, height: 321, rotation: 0, imageRotation: 0 },
        { id: "6", x: 880, y: 431, width: 198, height: 321, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h4v2-10",
    name: "PO 10 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 54, y: 135, width: 386, height: 288, rotation: 0, imageRotation: 0 },
        { id: "2", x: 54, y: 431, width: 386, height: 287, rotation: 0, imageRotation: 0 },
        { id: "3", x: 448, y: 135, width: 284, height: 472, rotation: 0, imageRotation: 0 },
        { id: "4", x: 740, y: 135, width: 340, height: 583, rotation: 0, imageRotation: 0 },       
        { id: "5", x: 448, y: 615, width: 139, height: 103, rotation: 0, imageRotation: 0 },
        { id: "6", x: 595, y: 615, width: 138, height: 103, rotation: 0, imageRotation: 0 }
    ],
}
];